import React from 'react';
import Button from '@/components/ui/Button';
import { Calendar, MapPin, Building2, DollarSign, Clock, Eye, Filter, Search, X, ChevronDown, TrendingUp, Briefcase, CheckCircle, Send } from 'lucide-react';
import Select from '@/components/ui/Select';
import Input from '@/components/ui/Input';

const FilterSection = ({ 
filters,
setFilters,
setShowFilters,
showFilters
}) => { 

const statusOptions = [
{ label: 'All', value:'',},
{ label: 'Submitted', value:'submitted',},
{ label: 'Shortlisted',value:'shortlisted',},
{ label: 'Interview scheduled',value:'interview_scheduled',},
{ label: 'Interview completed',value:'interview_completed',},
{ label: 'Rejected',value:'rejected',},
{ label: 'Upper round',value:'upper_round',},
{ label: 'Offer received', value:'offer_received',},
{ label: 'Hired', value:'hired',},
{ label: 'Withdrawn', value:'withdrawn',},
];

return (
<div className="bg-white rounded-lg shadow-sm p-4 mb-6 border border-gray-200">
<div className="flex flex-col md:flex-row gap-4">
{/* Search Bar */}
<div className="flex-1 relative">
<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
<Input
type="search"
placeholder="Search by job title or company..."
value={filters.search}
onChange={(e) => setFilters({ ...filters, search: e.target.value})}
className="pl-10 pr-4 border border-gray-200"
/>

</div>

{/* Filter Toggle Button */}
<button
onClick={() => setShowFilters(!showFilters)}
className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 text-sm transition-colors"
>
<Filter className="w-3 h-3" />
Filters
<ChevronDown className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
</button>
</div>

{/* Expandable Filters */} 
{showFilters && (
<div className="mt-4 pt-4 border-t border-gray-200 grid grid-cols-1 md:grid-cols-2 gap-4">
<div className="col-span-2">
<Select
label="Status"
options={statusOptions}
value={filters.status}
onChange={(status) => setFilters({ ...filters, status })}
/>
</div>

<div>
<Input
label="Date From"
type="date"
value={filters.dateFrom}
onChange={(e) => setFilters({ ...filters, dateFrom:e.target.value })}
className="mb-4 border border-gray-200"
/>
</div>

<div>
<Input
label="Date To"
type="date"
value={filters.dateTo}
onChange={(e) => setFilters({ ...filters, dateTo:e.target.value })}
className="mb-4 border border-gray-200"
/>
</div>
</div>
)}
</div>
);
};

export default FilterSection;